/**
 * Roles de usuario. Mapeo desde los perfiles de absoluteBUSY:
 * - X_admin    → ADMIN
 * - C_control  → GERENTE
 * - A_standard → USUARIO
 * - A_noreport → USUARIO + canViewReports=false (flag aparte en User)
 * - B_readonly → LECTOR
 */
export const Role = {
  ADMIN: 'ADMIN',
  GERENTE: 'GERENTE',
  USUARIO: 'USUARIO',
  LECTOR: 'LECTOR',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ALL_ROLES: readonly Role[] = Object.values(Role);
